<app-dialog-base [Title]='"Objects"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="tablewrap">
    <div class="table">
      <table fixedcols="[0]">
        <tr>
          <th>
            <switch-all-checkbox [items]="objects" />
          </th>
          <th>{{'Name'|translate }}</th>
        </tr>
        <tr *ngFor="let object of objects">
          <td><input type="checkbox" [(ngModel)]="object.IsChecked" (change)="onToggle(object)" /></td>
          <td>{{object.Name}}</td>
        </tr>
      </table>
    </div>
  </div>
</app-dialog-base>
